import { Injectable } from '@angular/core';
import { NgxImageCompressService } from 'ngx-image-compress';

@Injectable({
  providedIn: 'root'
})
export class ImageCompressionService {

  // check for double compression?

  constructor(private imageCompress: NgxImageCompressService) { }

   async compressImage(file: File, maxSizeInBytes: number): Promise<File | null> {
    try {
      const base64String = await this.fileToBase64(file);
      //console.log(`Original size: ${file.size} bytes`);
  
      let quality = 50;
      let width = 50;
      let height = 50;

      if (file.size > 10 * 1024 * 1024) {
        quality = 50;
        width = 50;
        height = 50;
      } else {
        quality = 70;
        width = 70;
        height = 70;
      }

      const compressedBase64 = await this.imageCompress.compressFile(base64String, quality, width, height);
      const compressedFile = this.dataURLtoFile(compressedBase64, file.name);
  
      //console.log(`Compressed size: ${compressedFile.size} bytes`);
  
      if (compressedFile.size > maxSizeInBytes) {
        return null; // Compression size not enough
      }
  
      return compressedFile;
    } catch (error) {
      console.error("Compression failed", error);
      return null;
    }
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  private dataURLtoFile(dataurl: string, filename: string): File {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
}


